<div class="country-info-view">
    <div class="country-info-view__banner">
        <img role="presentation" [src]="bannerImgUrl | safeUrl" loading="lazy" alt="banner">
        <div class="country-info-view__top-info">
            <p>{{ 'MAIN.TITLE' | translate }}</p>
            <p class="text">{{ defaultLocationName | replaceStr: ' ' | titlecase }} trip planner</p>
        </div>
        <button class="btn-default btn-primary" (click)="planAPerfectTrip()" [disabled]="isFetching">
            Plan a trip to {{ defaultLocationName | replaceStr: ' ' | titlecase }}
        </button>
    </div>

    <div class="country-info-view__content">
        <div id="element-id-5" class="country-info-view__main-info">
            <div class="country-info-view__breadcrumb">
                <app-simple-breadcrumb [breadcrumbs]="breadcrumbs"></app-simple-breadcrumb>
            </div>

            <div class="info-box">
                <div class="info-box__intro">
                    <div class="info-box__texts">
                        <h1>Things to do in {{ defaultLocationName | replaceStr: ' ' | titlecase }}</h1>

                        <div class="extra-info-box">
                            @if (!isFetching) {
                                <app-text-ellipsis
                                        [short]="cityDetails.thingsToDoShortDescription"
                                        [long]="cityDetails.thingsToDoLongDescription"
                                        [extra]="cityDetails.thingsToDoExtraDescription"
                                ></app-text-ellipsis>
                            } @else {
                                <ngx-skeleton-loader [theme]="{height: '20px', margin: 0}"></ngx-skeleton-loader>
                                <ngx-skeleton-loader
                                        [theme]="{height: '20px', margin: 0, marginTop: '7px'}"></ngx-skeleton-loader>
                                <ngx-skeleton-loader
                                        [theme]="{height: '20px', margin: 0, marginTop: '7px'}"></ngx-skeleton-loader>
                                <ngx-skeleton-loader
                                        [theme]="{height: '20px', margin: 0, marginTop: '7px'}"></ngx-skeleton-loader>
                                <ngx-skeleton-loader
                                        [theme]="{height: '20px', margin: 0, marginTop: '7px'}"></ngx-skeleton-loader>
                            }
                        </div>
                    </div>

                    <div class="info-box__anchors">
                        <p>
                            More in {{ defaultLocationName | replaceStr: ' ' | titlecase }}
                        </p>
                        <ul>
                            @if (!isFetching) {
                                @if ((categoriesResponse | keyvalue)?.length || isFetching) {
                                    <li>
                                        <a class="menu-link" (click)="scrollToAnchor(0, $event)">
                                            <img class="activities" src="assets/svg/ic-activities.svg"
                                                 alt="activities-icon">
                                            <span class="label-with-icon">
                    {{ 'VIATOR.ACTIVITIES' | translate }} >
                  </span>
                                        </a>
                                    </li>
                                }

                                @if (cityResponse?.attractions?.length || isFetching) {
                                    <li #linkRef>
                                        <a class="menu-link" (click)="scrollToAnchor(1, $event)">
                                            <img class="sign-post" src="assets/svg/ic-sign-post.svg"
                                                 alt="sign-post-icon">
                                            <span class="label-with-icon">
                    {{ 'ATTRACTION.ATTRACTIONS' | translate }} >
                  </span>
                                        </a>
                                    </li>
                                }

                                @if (occasionGeniusResponse?.eventsSearchedAndSortedCloned?.length || isFetching) {
                                    <li>
                                        <a class="menu-link" (click)="scrollToAnchor(2, $event)">
                                            <img class="event" src="assets/svg/ic-event.svg" alt="event-icon">
                                            <span class="label-with-icon">
                                                Events
                                            </span>
                                        </a>
                                    </li>
                                }

                                @if (voiceMapResponse?.guidedTours?.length || isFetching) {
                                    <li>
                                        <a class="menu-link" (click)="scrollToAnchor(3, $event)">
                                            <img class="headphones-duotone" src="assets/svg/ic-headphones-duotone.svg"
                                                 alt="headphones-duotone-icon">
                                            <span class="label-with-icon">
                                                {{ 'VOICE_MAP.VOICE_GUIDE' | translate }} >
                                              </span>
                                        </a>
                                    </li>
                                }
                            } @else {
                                <li>
                                    <ngx-skeleton-loader [theme]="{height: 20 + 'px', margin: 0}"></ngx-skeleton-loader>
                                </li>
                                <li>
                                    <ngx-skeleton-loader [theme]="{height: 20 + 'px', margin: 0}"></ngx-skeleton-loader>
                                </li>
                                <li>
                                    <ngx-skeleton-loader [theme]="{height: 20 + 'px', margin: 0}"></ngx-skeleton-loader>
                                </li>
                            }

                            <li>
                                @if (!isFetching) {
                                    <a class="menu-link" (click)="scrollToAnchor(5, $event)">
                                        <img class="info" src="assets/svg/ic-info.svg" alt="info-icon">
                                        <span class="label-with-icon">
                                        {{ 'THINGS_TO_DO.CITY_INFO' | translate }} >
                                      </span>
                                    </a>
                                } @else {
                                    <ngx-skeleton-loader [theme]="{height: 20 + 'px', margin: 0}"></ngx-skeleton-loader>
                                }
                            </li>
                        </ul>
                    </div>

                    <div class="info-box__popular">
                        <div class="info-box__itineraries">
                            <app-popular-itineraries
                                    [customTrips]="countryResponse.itineraries"
                                    [infoType]="eInfoType.COUNTRY"
                                    [isFetching]="isFetching"
                                    [showBrowseButton]="true"
                                    (browse)="scrollToAnchor(4)"
                            ></app-popular-itineraries>
                        </div>
                    </div>
                </div>

                <div class="info-box__locations" #locationsRef>
                    <div class="info-box__gallery">
                        @if (!isFetching) {
                            <app-gallery
                                    [isTripPlannerPage]="true"
                                    [isCityPage]="false"
                                    [items]="cityResponse.destinations"
                                    (selectedItem)="flyToGalleryItem($event)"
                            ></app-gallery>
                        } @else {
                            <ngx-skeleton-loader
                                    [theme]="{height: locationsRef.clientHeight + 'px', margin: 0}"></ngx-skeleton-loader>
                        }
                    </div>
                    <div class="info-box__map">
                        @if (!isFetching) {
                            <app-simple-map
                                    [coordinates]="thingsToDoService.mapCoordinates$ | async | parseCoordinates"
                            ></app-simple-map>
                        } @else {
                            <ngx-skeleton-loader
                                    [theme]="{height: locationsRef.clientHeight + 'px', margin: 0}"></ngx-skeleton-loader>
                        }
                    </div>
                </div>
            </div>
        </div>

        @if (cityDetails.place_id) {
            <section id="element-id-6" class="location-info">
                <div class="location-info__content">
                    <app-booking-banner
                            [countryName]="countryDetails.name"
                            [cityName]="cityDetails.name"
                    ></app-booking-banner>
                    <app-hotels-booking-container
                            [partialFilters]="true"
                            [city]="{id: cityDetails.place_id, cityName: cityDetails.name}"
                            [country]="{id: null, countryName: countryDetails.name}"
                    ></app-hotels-booking-container>
                </div>
                <div class="location-info__footer"></div>
            </section>
        }

        @if ((categoriesResponse | keyvalue)?.length || isFetching) {
            <section class="location-info" id="element-id-0">
                <div class="location-info__header location-info__header--col">
                    <div class="title-box title-box--with-icon">
                        <h2 class="title-box__title">
                            {{ 'VIATOR.BOOK_ACTIVITIES_IN' | translate: {city: defaultLocationName | replaceStr: ' ' | titlecase} }}
                        </h2>
                        <span class="viator-logo title-box__title title-box__title--with-icon">
              {{ 'WITH' | translate }} <img src="assets/svg/viator-logo.svg" alt="voice-map">
            </span>
                    </div>
                    <p class="description-box">
                        {{ 'VIATOR.LOOKING_FOR_SOME_THINGS' | translate: {location: defaultLocationName | replaceStr: ' ' | titlecase} }}
                    </p>
                </div>

                <div class="location-info__content">
                    <app-viator
                            [cityId]="cityDetails?.place_id"
                            [cityName]="cityDetails?.name"
                            [countryName]="countryDetails.name"
                            [categories]="categoriesResponse"
                            [isFetching]="isFetching"
                            (numOfHurt)="numOfHurt = $event"
                    ></app-viator>
                </div>
                <div class="location-info__footer"></div>
            </section>
        }

        @if (cityResponse?.attractions?.length || isFetching) {
            <section class="location-info" id="element-id-1">
                <div class="location-info__header">
                    <h2 class="align-filter">
                        {{ 'ATTRACTION.ATTRACTION_IN' | translate: {country: defaultLocationName | replaceStr: ' ' | titlecase} }}
                    </h2>
                    <app-search-input-field
                            [placeholder]="'ATTRACTION.ATTRACTION' | translate"
                            [disabled]="isFetching"
                            (searchChanged)="cityResponse.filterAndSortAttractions($event)"
                    ></app-search-input-field>
                </div>
                <div class="location-info__content">
                    <app-places-list
                            [places]="cityResponse.attractionsSearchedAndSorted"
                            [isAttractions]="true"
                            [isFetching]="isFetching"
                    ></app-places-list>
                </div>
                <div class="location-info__footer"></div>
            </section>
        }

        @if (occasionGeniusResponse?.eventsSearchedAndSortedCloned?.length || isFetching) {
            <section class="location-info" id="element-id-2">
                <div class="location-info__header">
                    <h2 class="align-filter">
                        {{ 'OCCASION_GENIUS.EVENT_COLANDER_THINGS_TO_DO_IN' | translate: {location: defaultLocationName | replaceStr: ' ' | titlecase} }}
                    </h2>
                    <app-search-input-field
                            [placeholder]="'OCCASION_GENIUS.SEARCH_PLACEHOLDER' | translate: {location: defaultLocationName | replaceStr: ' ' | titlecase} "
                            [showSortDirection]="false"
                            [disabled]="isFetching"
                            (searchChanged)="occasionGeniusResponse.filterAndSortEvents($event)"
                    ></app-search-input-field>
                </div>
                <div class="location-info__content">
                    <app-occasion-genius
                            [cityId]="cityDetails.place_id"
                            [cityName]="defaultLocationName | replaceStr: ' ' | titlecase"
                            [countryName]="countryDetails.name"
                            [isFetching]="isFetching"
                            [occasionGeniusResponse]="occasionGeniusResponse"
                            [eventsSearchedAndSorted]="occasionGeniusResponse.eventsSearchedAndSorted"
                    ></app-occasion-genius>
                </div>
                <div class="location-info__footer"></div>
            </section>
        }

        @if (voiceMapResponse?.guidedTours?.length || isFetching) {
            <section class="location-info" id="element-id-3">
                <div class="location-info__header location-info__header--col">
                    <div class="title-box title-box--with-icon">
                        <h2 class="title-box__title">
                            {{ defaultLocationName | replaceStr: ' ' | titlecase }} City voice guide
                        </h2>
                        <span class="viator-logo title-box__title title-box__title--with-icon">
              {{ 'WITH' | translate }} <img class="voice-map-icon"
                                            src="https://res.cloudinary.com/djxk74uhg/image/fetch/f_auto/https://cdn.routeperfect.com/app/images/images/voice-map.png?_a=ATFGlAA0"
                                            loading="lazy" alt="voice-map">
            </span>
                    </div>
                    <p class="description-box">
                        {{ 'VOICE_MAP.DESCRIPTION' | translate }}
                    </p>
                </div>

                <div class="location-info__content">
                    <app-audio-tours
                            [itineraryItem]="voiceMapResponse.guidedTours"
                            [isFetching]="isFetching"
                            [countryName]="countryDetails.name"
                            [cityName]="cityDetails.name"
                    ></app-audio-tours>
                </div>

                <div class="location-info__footer"></div>
            </section>
        }

        @if (countryResponse?.itineraries?.length || isFetching) {
            <section class="location-info" id="element-id-4">
                <div class="location-info__header">
                    <h2>{{ 'DESTINATION.POPULAR_TRIPS_IN' | translate: {country: countryDetails?.name} }}</h2>
                </div>
                <div class="location-info__content">
                    <app-trips-list
                            [trips]="countryResponse.itineraries"
                            [country]="countryDetails.name"
                            [isFetching]="isFetching"
                    ></app-trips-list>
                </div>
            </section>
        }
    </div>
</div>
